<template>
  <!-- 自动审批全部查询 -->
  <div class="automatic-record-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="AUTO_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <!-- <div class="text-right">
        <a-button @click="exportTable" type="primary">导出</a-button>
      </div> -->
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
        row-key="key"
      >
        <template v-slot:applyAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.applyAmount)"></span>
        </template>

        <template v-slot:approveAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.approveAmount)"></span>
        </template>

        <template v-slot:type="{ tableRow }">
          <span>{{ CREDIT_TYPE_OBJ[tableRow.type] }}</span>
        </template>

        <!-- <template v-slot:status="{ tableRow }">
          <a-tag
            :color="MY_APPROVE_STATUS_OBJ[tableRow.status].color"
            style="width: 70px; text-align: center;"
          >
            {{ MY_APPROVE_STATUS_OBJ[tableRow.status].label }}
          </a-tag>
        </template> -->

        <!-- <template v-slot:bpStatus="{ tableRow }">
          <a-tag
            :color="APPROVE_STATUS_COLOR_OBJ[tableRow.bpStatus]"
            style="width: 70px; text-align: center;"
          >
            {{ tableRow.bpStatus }}
          </a-tag>
        </template> -->

        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            查看
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { AUTO_SEARCH_SCHEMA } from './schema'
import { APPROVE_STATUS_COLOR_OBJ, MY_APPROVE_STATUS_OBJ } from './const'
import { CREDIT_TYPE_OBJ } from '../const'
import {
  getAutoList,
  // exportList
} from './api'
import { formatParamDate } from 'utils/util'

export default {
  name: 'automatic-record-list',
  data() {
    const query = this.$route.query
    const initSearchForm = {
      applyEnd: '',
      applyStart: '',
      approveEnd: '',
      approveStart: '',
      bpStatus: '',
      companyCode: '',
      companyName: '',
      id: '',
      status: (query.status && String(query.status)) || '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      AUTO_SEARCH_SCHEMA,
      APPROVE_STATUS_COLOR_OBJ,
      MY_APPROVE_STATUS_OBJ,
      CREDIT_TYPE_OBJ,
      initSearchForm,
      searchForm,
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '企业名称',
          align: 'left',
          dataIndex: 'companyName',
        },
        {
          title: '企业ID',
          dataIndex: 'companyCode',
          align: 'left',
          width: 150,
        },
        {
          title: '审批金额(元)',
          dataIndex: 'applyAmountStr',
          align: 'left',
          width: 130,
        },
        {
          title: '货币',
          dataIndex: 'moneyType',
          align: 'center',
          width: 90,
        },
        {
          title: '审批账期(天)',
          dataIndex: 'termStr',
          align: 'center',
          width: 130,
        },
        {
          title: '信用类型',
          scopedSlots: { customRender: 'type' },
          align: 'center',
          width: 120,
        },
        {
          title: '大区/区域',
          dataIndex: 'region',
          align: 'left',
          width: 130,
        },
        {
          title: '审批人',
          dataIndex: 'approver',
          align: 'left',
          width: 130,
        },
        {
          title: '审批时间',
          dataIndex: 'approveDate',
          align: 'center',
          width: 200,
        },
        {
          title: '自动审批结果',
          dataIndex: 'statusStr',
          align: 'center',
          width: 150,
        },
        {
          title: '自动审批不通过原因',
          dataIndex: 'remark',
          align: 'left',
          width: 200,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      SCROLL: { x: 1850 },
    }
  },
  mounted() {
    this._getRecordList(this.initSearchForm)
  },
  methods: {
    async _getRecordList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getAutoList(formData)
        this.pageData.total = total
        this.tableData = records.map(item => {
          item.key = `${item.id}_${item.approveDate}`
          return item
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(
        data,
        data.applyRangeDate,
        'applyStart',
        'applyEnd',
      )
      data = formatParamDate(
        data,
        data.approveRangeDate,
        'approveStart',
        'approveEnd',
      )
      delete data.applyRangeDate
      delete data.approveRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getRecordList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getRecordList(this.searchForm)
    },
    handleView(row) {
      const { id, type, status } = row
      this.$router.push({
        path: `/credit-approval/apply-detail/${id}`,
        query: {
          type,
          status,
          auto: true,
        },
      })
    },
    // exportTable() {
    //   const params = {
    //     ...this.searchForm,
    //   }
    //   exportList(params)
    // },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
